
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CheckCircle, Loader2 } from 'lucide-react';

export const MagicVerify: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verifyMagic } = useAuth();
  const [status, setStatus] = useState<'verifying' | 'success'>('verifying');
  
  // Simulate token verification
  useEffect(() => {
    const verify = async () => {
      const token = searchParams.get('token');
      if (!token) {
        navigate('/');
        return;
      }

      try {
        await verifyMagic(token);
        setStatus('success');
        setTimeout(() => navigate('/library'), 800);
      } catch (err) {
        console.error(err);
        navigate('/');
      }
    };
    verify();
  }, [verifyMagic, navigate, searchParams]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-paper-bg dark:bg-night-bg">
      {status === 'verifying' ? (
        <>
          <Loader2 className="animate-spin text-brand-blue mb-4" size={48} />
          <h1 className="text-xl font-bold mb-2">Verifying Magic Link...</h1>
          <p className="opacity-60">Just a moment while we sign you in.</p>
        </>
      ) : (
        <div className="animate-in zoom-in duration-300">
          <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={32} />
          </div>
          <h1 className="text-xl font-bold mb-2">Successfully Signed In!</h1>
          <p className="opacity-60">Redirecting to your library...</p>
        </div>
      )}
    </div>
  );
};
